<template>

  <!-- TABLE -->
  <tr v-if="vmode === 'table'"
  :class="{'selected': selected[item.tempID]}">
    <td class="sticky">
      <v-layout align-center>

        <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              color="red"
              v-on="on"
            >
              <v-icon small>mdi-android-debug-bridge</v-icon>
            </v-btn>
          </template>
          <v-card outlined class="elevation-0">
            <v-layout class="backgroundCard pa-2 caption">
              JSON
            </v-layout>
            <div class="c-hr"></div>
            <div class="pa-3">
              <span class="caption">
                {{ item }}
              </span>
            </div>
          </v-card>
        </v-menu>

        
        <v-icon class="drag-handle" color="">
          menu
        </v-icon>

        <v-btn
        icon
        text
        class="ma-0"
        @click.stop="$emit('checkRow', item)">
          <v-icon :color="selected[item.tempID] ? 'color1' : ''"> 
            {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>

        <c-input v-if="isCustomRow" :value.sync="item.json_data.name" class="crx-box-input"></c-input>
  
        <peek-definition v-else :definition="item.definition" :searchString="searchText" style="white-space: normal;">
        </peek-definition>
        <!-- <img class="" src="@/assets/img/illustrations/cream.png" alt="cardboard box" width="26px">
        <span class="ml-2 text-ellipsed" v-html="highlightedName">
          
        </span>
        -->
      </v-layout>
    </td>
    <td>
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue.sync="item.quantity"
      :key="'c' + (item.definition || {}).id"
      :metric.sync="currentMetric"
      class="crx-box-input"
      ></c-ms-ii>
      <!--
      <c-metric-selector
      :inventoryItemID="item.inventory_item_id" 
      :realValue.sync="item.quantity"
      :metric.sync="currentMetric"
      ></c-metric-selector>
      -->
    </td>
    <td>
      <c-ms-ii
      sid="si-mass-g"
      :realValue.sync="item.weight"
      class="crx-box-input"
      ></c-ms-ii>
    </td>
    <td>
      <v-row class="align-center">

        <c-cost-per-unit 
        :realCost.sync="item.cost_per_unit"
        :definition="item.definition"
        :metric="currentMetric"
        :class="['crx-box-input', {'orange--text': !priceMatch && priceListValue !== '-'}]"
        :currencyLabel="currencyLabel">
        </c-cost-per-unit>

        <!-- MENU -->
        <v-menu 
        transition="scale-transition"
        offset-y
        max-width="300px"
        >
  
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
            >
              <v-icon small :color="infoColor">mdi-currency-usd</v-icon>
            </v-btn>
          </template>
          <v-card class="pa-2">

            <v-layout justify-center>
              <span class="caption text-uppercase text--text text--darken-1">Price List</span>
            </v-layout>

            <div class="c-hr ma-2"></div>

            <div :class="['title text-center', {'amber--text': !priceMatch}, {'green--text': priceMatch}]">
              {{ item.cost_per_unit }}
              <span class="caption grey--text">{{ currencyLabel }}</span>
            </div>

              <template v-if="priceTable">

                <table class="final-table full-width lines-b lines-r hover pointer">
                  <colgroup ref="colgroup2">
                    <col width="50%">
                    <col width="50%">
                  </colgroup>
                  <tr>
                    <th>Quantity</th>
                    <th>Price ({{ currencyLabel }})</th>
                  </tr>
                  
                  <tr 
                  v-for="(col, index) of priceTable" :key="index" 
                  @click="item.cost_per_unit = col.price">
                    <td :class="{'font-weight-medium': index === priceListColumnIndex}">
                      <c-ms-ii
                      :metric_definition="item.definition" 
                      :realValue.sync="col.quantity"
                      :key="'c' + (item.definition || {}).id"
                      labelMode
                      alwaysScale
                      ></c-ms-ii>
                    </td>
                    <td :class="[{'amber--text': (Number(col.price) === item.cost_per_unit) && index !== priceListColumnIndex}, {'green--text': (Number(col.price) === item.cost_per_unit) && index === priceListColumnIndex}]">
                      {{ col.price || '(not set)' }}
                      <v-icon v-if="index === priceListColumnIndex" small color="green">mdi-check-circle-outline</v-icon>
                    </td>
                  </tr>
                  
                </table>

              </template>

              <v-layout v-else>
                This price list contains no data for this item and currency
              </v-layout>

          </v-card>
        </v-menu>

        <!-- END MENU -->
      </v-row>
    </td>
    <td>
      <c-price :quantity.sync="item.total_cost" :focussed.sync="totalCostHasFocus" :currency="currency" class="crx-box-input">
      </c-price>
    </td>
    <td>
      <c-input :value.sync="item.discount" class="crx-box-input"></c-input>
    </td>
    <td class="text-end">
      <c-price :quantity="automaticTotalCostMinusDiscount" labelMode :currency="currency">
      </c-price>
    </td>
  </tr>
</template>

<script>
import {BigNumber} from 'bignumber.js'
import PeekDefinition from '@/components/peek/inventory-def-name'

export default {
  props:['item', 'vmode', 'searchText', 'selected', 'priceList', 'currency'],
  components: {
    PeekDefinition
  },
  data () {
    return {
      hover: false,
      currentMetric: 0,
      totalCostHasFocus: false
    }
  },
  computed: {
    isCustomRow () {
      if (this.item.json_data) {
        return true
      }
      return false
    },
    infoColor () {
      if (this.priceMatch) {
        return 'green'
      } else if (this.priceListValue === '-') {
        return 'grey'
      } else {
        return 'amber'
      }
    },
    currencyLabel () {
      return (this.$store.state.db.currencies.items[this.currency] || {}).symbol
    },
    priceTable () {
      var priceTable = this.priceList[this.item.inventory_item_id] || {}
      var json_data = priceTable.json_data || {}
      if (!json_data[this.currency]) {
        return null
      }
      var table = JSON.parse(JSON.stringify(json_data[this.currency]))
      if (table) {
        table.sort((a, b) => a.quantity-b.quantity)
      }
      return table
    },
    priceListColumnIndex () {
      if (this.priceTable) {
        var index = 0
        for (var i = 0; i < this.priceTable.length; i++) {
          if (this.priceTable[i].quantity > this.item.quantity) {
            continue
          }
          index = i
        }
        return index
        /* var column = this.priceTable.reduce((a, i) => {
          if (i.quantity <= this.item.quantity && i.quantity > a) {
            a = i.quantity
          }
          return a
        }, 0)
        var index = this.priceTable.map(item => item.quantity).indexOf(column)
        return index */
      }
      return null
      /* if (this.priceTable) {
        var column = this.priceTable.cols.reduce((a, i) => {
          if (i <= this.item.quantity && i > a) {
            a = i
          }
          return a
        }, 0)
        var index = this.priceTable.cols.indexOf(column)
        return index
      }
      return null */
    },
    priceListValue () {
      if (this.priceListColumnIndex !== null && this.priceTable) {
        return this.priceTable[this.priceListColumnIndex].price
      }
      return '-'
    },
    priceMatch () {
      return Number(this.priceListValue) === Number(this.item.cost_per_unit)
    },
    highlightedName () {
      var replacedStr = (this.searchText || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.item.definition.name.replace(new RegExp(replacedStr, 'gi'), '<span class="color1--text">$&</span>')
      return '<span class="font-weight-regular">' + replacedStr + '</span>'
    },
    quantityInUnits () {
      switch (this.currentMetric) {
        case 0:
          return this.item.quantity
        case 1:
          // ml - litres
          return new BigNumber(this.item.quantity).dividedBy(1000)
        case 2:
          // mg - kg
          return new BigNumber(this.item.quantity).dividedBy(1000 * 1000)
        case 3:
          // mm - m
          return new BigNumber(this.item.quantity).dividedBy(1000)
      }
    },
    automaticTotalCost () {
      return new BigNumber(this.quantityInUnits).times(this.item.cost_per_unit).toNumber()
    },
    automaticTotalCostMinusDiscount () {
      var discount = new BigNumber(100 - this.item.discount).dividedBy(100)
      return new BigNumber(this.item.total_cost).times(discount).toNumber()
    },
    automaticCostPerUnit () {
      return new BigNumber(this.item.total_cost).dividedBy(this.quantityInUnits).toNumber()
    }
  },
  watch: {
    'item.quantity' (nv) {
      if (!this.item.definition) {
        // as is the case with a cusom item
        return 
      }
      this.item.weight = this.item.definition.weight * nv
    },
    automaticTotalCost (nv) {
      if (!this.totalCostHasFocus) {
        this.item.total_cost = this.automaticTotalCost
      }
    },
    automaticCostPerUnit (nv) {
      if (this.totalCostHasFocus) {
        this.item.cost_per_unit = isFinite(nv) ? nv : 0 
        // isFinite is necessary because if you dont enter a quantity & unit cost and first enter the total cost
        // it will set unit cost to 'infinity'



        // this.item.total_cost = this.automaticTotalCost
        /* if (isNaN(this.item.cost_per_unit)) {
          this.item.cost_per_unit = 0
        } */
      }
    }
  },
  created () {
  }
}
</script>

<style scoped lang="scss">

</style>